{
  "name": "dtis-ng-components",
  "version": "1.35.0",
  "scripts": {
    "ng": "nx",
    "mock": "tsx tools/mock-server/server.ts",
    "mock:prism": "prism mock mock.openapi.yaml ",
    "mock:ultrasonic": "prism mock apps/dtis-ultrasonic-ui/swagger.json --port 4010",
    "start:ultrasonic-mock": "concurrently \"pnpm mock:ultrasonic\" \"nx serve dtis-ultrasonic --host=127.0.0.1 --configuration=dev-mock\"",
    "start:mock": "concurrently \"pnpm mock\" \"nx serve dtis-ng-components --host=127.0.0.1 --configuration=dev-cloud-mock\"",
    "serve": "nx run-many -t serve --host=127.0.0.1 --configuration=dev",
    "start": "nx run-many -t serve --host=127.0.0.1 ",
    "start:prod": "nx run-many -t serve --host=127.0.0.1 --configuration=production",
    "start:app": "nx serve dtis-ng-components --host=127.0.0.1 ",
    "start:admin": "nx serve dtis-admin --host=127.0.0.1 ",
    "build": "nx run-many -t build",
    "biome-lint": "biome lint",
    "lint": "nx run-many -t biome-lint --parallel=3",
    "lint:affected": "nx affected -t lint --parallel=3",
    "lint:fix": "nx run-many -t lint --parallel=3 --fix",
    "e2e:watch": "nx e2e dtis-test --runner-ui  --headed",
    "e2e": "pnpm run test:e2e",
    "e2e:component-test": "nx component-test dtis-ng-components",
    "test": "nx run-many -t test",
    "test:project": "nx test",
    "test:ut": " nx test dtis-ultrasonic-ui",
    "test:watch": "BABEL_DISABLE_CACHE=1  nx test dtis-ng-components --watchAll --coverage",
    "test:e2e": "NODE_OPTIONS='--max-old-space-size=4096' nx e2e dtis-test --browser=electron --verbose",
    "release:prepare": "npx release-please release-pr --token=$GITHUB_TOKEN --repo-url=Schaeffler-Group/dtis-ng-components",
    "release:artifact": "npx release-please github-release --token=$GITHUB_TOKEN --repo-url=Schaeffler-Group/dtis-ng-components",
    "prepare": "husky"
  },
  "private": true,
  "dependencies": {
    "@angular/cdk": "22.1.6",
    "@angular/common": "22.1.6",
    "@angular/compiler": "22.1.6",
    "@angular/core": "22.1.6",
    "@angular/forms": "22.1.6",
    "@angular/material": "22.1.6",
    "@angular/platform-browser": "22.1.6",
    "@angular/platform-browser-dynamic": "22.1.6",
    "@angular/router": "22.1.6",
    "@azure/msal-angular": "6.2.0",
    "@azure/msal-browser": "5.21.0",
    "@fontsource/noto-sans": "^5.3.0",
    "@fontsource/roboto": "^5.3.0",
    "@jsverse/transloco": "^8.4.0",
    "@microsoft/applicationinsights-web": "~3.4.4",
    "@microsoft/microsoft-graph-client": "^3.0.7",
    "@ngxs/devtools-plugin": "22.0.0",
    "@ngxs/router-plugin": "^22.0.0",
    "@ngxs/storage-plugin": "^22.0.0",
    "@ngxs/store": "22.0.0",
    "@nx/angular": "23.2.1",
    "@nx/cypress": "23.2.1",
    "@schaeffler/empty-states": "^3.1.0",
    "@schaeffler/styles": "^1.14.1",
    "angular-svg-icon": "^19.1.1",
    "chroma-js": "^3.2.0",
    "colorjs.io": "^0.7.1",
    "date-fns": "4.4.0",
    "dexie": "^4.4.5",
    "echarts": "^6.1.0",
    "file-saver": "^2.0.5",
    "immer": "^11.1.18",
    "jszip": "^3.10.2",
    "material-icons": "^1.13.14",
    "mathjs": "^15.2.0",
    "modern-screenshot": "^4.7.0",
    "ngx-capture": "^0.14.0",
    "ngx-echarts": "^22.0.0",
    "ngx-papaparse": "^8.0.0",
    "rxjs": "~7.8.2",
    "tslib": "^2.8.1",
    "uuid": "^14.0.2",
    "zone.js": "0.16.3"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "22.1.4",
    "@angular-devkit/core": "22.1.7",
    "@angular-devkit/schematics": "22.1.7",
    "@angular/cli": "~22.1.7",
    "@angular/compiler-cli": "22.1.6",
    "@angular/language-service": "22.1.6",
    "@babel/core": "^8.0.0",
    "@biomejs/biome": "^2.5.12",
    "@cypress/webpack-dev-server": "6.0.0",
    "@juggle/resize-observer": "^3.4.0",
    "@microsoft/microsoft-graph-types": "^2.43.1",
    "@ngneat/spectator": "22.1.0",
    "@ngxs/logger-plugin": "^22.0.0",
    "@nx/jest": "23.2.1",
    "@nx/js": "23.2.1",
    "@nx/web": "23.2.1",
    "@nx/workspace": "23.2.1",
    "@schematics/angular": "22.1.7",
    "@swc-node/register": "1.12.1",
    "@swc/core": "1.16.2",
    "@swc/helpers": "0.5.23",
    "@tailwindcss/postcss": "^4.3.3",
    "@types/chroma-js": "^3.1.2",
    "@types/file-saver": "^2.0.7",
    "@types/jest": "30.0.0",
    "@types/node": "26.3.0",
    "babel-loader": "^10.1.1",
    "concurrently": "^10.0.5",
    "cypress": "16.0.0",
    "fake-indexeddb": "^6.2.5",
    "html-webpack-plugin": "^5.6.8",
    "https-proxy-agent": "9.1.0",
    "husky": "^9.1.7",
    "jest": "30.5.1",
    "jest-environment-jsdom": "30.5.1",
    "jest-junit": "^17.0.0",
    "jest-preset-angular": "17.0.0",
    "jest-util": "30.5.1",
    "lint-staged": "^17.5.0",
    "nx": "23.2.1",
    "prettier": "^3.9.6",
    "prettier-plugin-tailwindcss": "^0.8.1",
    "resize-observer-polyfill": "^1.5.1",
    "tailwindcss": "^4.3.3",
    "ts-jest": "29.4.12",
    "ts-node": "^10.9.2",
    "typescript": "6.0.3",
    "wait-on": "^9.1.0"
  },
  "lint-staged": {
    "*.{js,ts,cjs,mjs,d.cts,d.mts,jsx,tsx,json,jsonc}": [
      "biome check --write --no-errors-on-unmatched --diagnostic-level=error"
    ]
  }
}
